import { adminClient as apolloClient } from '@/store/apollo';

import PointOfSaleGql from '@/extensions/shop/pointOfSale/store/graphql/queries/PointOfSale.gql';
import CreatePointOfSaleGql from '@/extensions/shop/pointOfSale/store/graphql/mutations/CreatePointOfSale.gql';
import UpdatePointOfSaleGql from '@/extensions/shop/pointOfSale/store/graphql/mutations/UpdatePointOfSale.gql';
import RegisterFiskalyClientGql from '@/extensions/shop/pointOfSale/store/graphql/mutations/RegisterFiskalyClient.gql';
import DeletePointOfSaleGql from '@/extensions/shop/pointOfSale/store/graphql/mutations/DeletePointOfSale.gql';
import PointsOfSalePaginatedGql from '@/extensions/shop/pointOfSale/store/graphql/queries/PointsOfSalePaginated.gql';

// The mailbox's POS links: the output field is `points_of_sale`; the input accepts
// only `pointsOfSale: [{ id }]`. Translate and drop the output field before saving.
const normalizeMailboxPointsOfSale = pointOfSale => {
    if (pointOfSale && pointOfSale.mailbox) {
        const posLinks = pointOfSale.mailbox.pointsOfSale || pointOfSale.mailbox.points_of_sale;
        if (posLinks) {
            pointOfSale.mailbox.pointsOfSale = posLinks.map(linked => ({ id: linked.id }));
        }
        delete pointOfSale.mailbox.points_of_sale;
    }
    return pointOfSale;
};

export default {
    fetchPointsOfSalePaginated: (data, shopID, cmsID) => new Promise((resolve, reject) => {

        let filters = []
        _.each(data.filters, entry => filters.push(entry))

        apolloClient.query({
            query: PointsOfSalePaginatedGql,
            variables: {
                currentPage: _.get(data, 'pageInfo.currentPage', 1),
                perPage: _.get(data, 'pageInfo.perPage', 25),
                order: _.get(data, 'variables.order', 'id'),
                direction: _.get(data, 'variables.direction', 'asc'),
                shop: parseInt(shopID),
                cms: cmsID ? parseInt(cmsID) : null,
                filters,
            }
        })
            .then(({ data }) => resolve(data.EX_POS_PointsOfSalePaginated))
            .catch(err => reject(err))
    }),
    fetchPointOfSale: (posId) => new Promise((resolve, reject) => {
        let filters = []
        // _.each(data.filters, entry => filters.push(entry))

        apolloClient.query({
            query: PointOfSaleGql,
            fetchPolicy: 'no-cache',
            variables: {
                id: parseInt(posId)
            }
        })
            .then(({ data }) => resolve(data.EX_POS_PointOfSale))
            .catch(err => reject(err))
    }),
    create: pointOfSale => {
        if (pointOfSale === undefined) throw new Error('required argument is missing')

        pointOfSale = _.removeDeepByKey(pointOfSale, '__typename')
        pointOfSale = normalizeMailboxPointsOfSale(pointOfSale)
        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: CreatePointOfSaleGql,
                variables: { pointOfSale }
            })
                .then(async ({ data }) => {
                    await apolloClient.clearStore()
                    resolve(data.EX_POS_CreatePointOfSale)
                })
                .catch(err => reject(err))
        })
    },
    update: pointOfSale => {
        if (pointOfSale === undefined) throw new Error('required argument is missing')

        pointOfSale = _.removeDeepByKey(pointOfSale, '__typename')
        pointOfSale = normalizeMailboxPointsOfSale(pointOfSale)
        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: UpdatePointOfSaleGql,
                variables: { pointOfSale }
            })
                .then(async ({ data }) => {
                    await apolloClient.clearStore()
                    resolve(data.EX_POS_UpdatePointOfSale)
                })
                .catch(err => reject(err))
        })
    },
    deletePointOfSale: id => new Promise((resolve, reject) => {
        apolloClient.mutate({
            mutation: DeletePointOfSaleGql,
            variables: { id: parseInt(id) }
        })
            .then(async ({ data }) => {
                await apolloClient.clearStore()
                resolve(data.EX_POS_DeletePointOfSale)
            })
            .catch(err => reject(err))
    }),
    registerFiskalyClient: pointOfSaleId => new Promise((resolve, reject) => {
        apolloClient.mutate({
            mutation: RegisterFiskalyClientGql,
            variables: { pointOfSaleId: parseInt(pointOfSaleId) }
        })
            .then(async ({ data }) => {
                await apolloClient.clearStore()
                resolve(data.EX_POS_RegisterFiskalyClient)
            })
            .catch(err => reject(err))
    }),
};
